// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--LBMYH";
export var container = "footer-module--container--b8xUe";
export var itemWrap = "footer-module--itemWrap--BaDXC";
export var policy = "footer-module--policy--xaaLD";